import { ref, useContext } from "@nuxtjs/composition-api";
import getProductAttachmentsGql from "./getProductAttachments.gql";
function useProductAttachments() {
  const loading = ref(false);
  const error = ref({
    load: null
  });
  const { app: { $vsf: { $magento } } } = useContext();
  const attachmentBaseUrl = `${$magento.config.magentoBaseUrl}/media/productattach`;
  const load = async (uid) => {
    let result = null;
    try {
      loading.value = true;
      const { data } = await $magento.api.customQuery({ query: getProductAttachmentsGql, queryVariables: { uid } });
      result = (data == null ? void 0 : data.ProductAttachments) ? data.ProductAttachments.sort((a, b) => {
        return a.name > b.name ? 1 : -1;
      }) : null;
    } catch (err) {
      error.value.load = err;
    } finally {
      loading.value = false;
    }
    return result;
  };
  const getAttachmentUrl = (attachment) => {
    return attachment.url ? attachment.url : attachmentBaseUrl + attachment.file;
  };
  return {
    loading,
    load,
    error,
    getAttachmentUrl
  };
}
export {
  useProductAttachments
};
